import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=97eb67f6&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports